export default "__VITE_ASSET__SXI0TeVM__"